import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import customAxios from "lib/axios";
import useAppDispatch from "hooks/useAppDispatch";
import { show } from "store/reducers/notifications.reducer";
import { useTranslation } from "react-i18next";

const ALLOWED_REDIRECTS = new Set([
  "/tradingrobots/main",
  "/strategies",
  "/strategies?view=shared",
  "/strategies?tab=shared",
  "/robots",
  "/robots?view=shared",
  "/robots?tab=shared",
  "/builder",
  "/myvalidation",
  "/tournament",
  "/tradingview",
]);

const REDIRECT_ALIASES = {
  conector: "/tradingrobots/main",
  connector: "/tradingrobots/main",
  estrategias: "/strategies",
  strategies: "/strategies",
  estrategiascompartidas: "/strategies?view=shared",
  sharedstrategies: "/strategies?view=shared",
  estrategias_shared: "/strategies?view=shared",
  "estrategias-compartidas": "/strategies?view=shared",
  robots: "/robots",
  robotscompartidos: "/robots?view=shared",
  sharedrobots: "/robots?view=shared",
  robots_shared: "/robots?view=shared",
  "robots-compartidos": "/robots?view=shared",
  builder: "/builder",
  validador: "/myvalidation",
  validation: "/myvalidation",
  dashboard: "/builder",
  torneo: "/tournament",
  tournament: "/tournament",
  tradingview: "/tradingview",
};

const AutoLogin = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [t] = useTranslation(["login"]);

  useEffect(() => {
    const autoLogin = async () => {
      const searchParams = new URLSearchParams(location.search);
      const userHash = searchParams.get('userHash');
      const redirectParam =
        (searchParams.get("redirect") ||
          searchParams.get("next") ||
          searchParams.get("page") ||
          "connector").trim();

      const normalized = redirectParam.toLowerCase();
      let redirectTo = "/tradingrobots/main";

      if (redirectParam.startsWith("/") && ALLOWED_REDIRECTS.has(redirectParam)) {
        redirectTo = redirectParam;
      } else if (REDIRECT_ALIASES[normalized]) {
        redirectTo = REDIRECT_ALIASES[normalized];
      }

      if (!userHash) {
        dispatch(show({ type: "error", msg: t("noToken")}));
        return history.push('/');
      }

      try {
        const response = await customAxios.post("autoLogin", {
            hashUserId: userHash
          });

        if (response.data.success) {
          localStorage.setItem("user_id", response.data.user_id);
          dispatch(show({ type: "success", msg: t("sesionOK")}));
          window.location.href = redirectTo;
        } else {
          dispatch(show({ type: "error", msg: t("invalidToken")}));
          return history.push('/');
        }
      } catch (error) {
        dispatch(show({ type: "error", msg: t("invalidToken")}));
        return history.push('/');
      }
    };

    autoLogin();
  }, [location, history, dispatch, t]);

  return <div>{t("procesingAcces")}</div>;
};

export default AutoLogin;
